<template>
    <div class="position-box">
        <div class="head">
            <img class="back" src="@/assets/icon_back.png" @click="goBack" alt="back">
            <div class="title">{{$t('bzhl.dd')}}</div>
            <router-link to="/activityRule" tag="div"><span class="icon">{{$t('bzhl.cjwt')}}</span></router-link>
        </div>
        <div class="cont-box"  @scroll="listenScroll">
          <div class="sy-wrap">
              <div class="sy-box">
                  <div class="t1">{{this.$t('langNew.zsy')}}({{currency}})</div>
                  <div class="money" v-if="currency == 'BTC'">{{profitTotal.total_profit | toFixed4}}</div>
                  <div class="money" v-else>{{profitTotal.total_profit | toFixed2}}</div>
                  <img class="bg1" src="@/assets/Line.png" alt="">
                  <img class="bg2" src="@/assets/Round-frame.png" alt="">
              </div>
              <img class="xian1" src="@/assets/xian1.png" alt="">
              <div class="box box1">
                  <p class="title">{{this.$t('bzhl.ddsl')}}</p>
                  <p class="num">{{profitTotal.order_cnt}}</p>
              </div>
              <img class="xian2" src="@/assets/xian2.png" alt="">
              <div class="box box2">
                  <p class="title">{{this.$t('hyjy.zje')}}</p>
                  <p class="num" v-if="currency == 'BTC'">{{profitTotal.total_amount | toFixed4}}</p>
                  <p class="num" v-else>{{profitTotal.total_amount | toFixed2}}</p>
              </div>
              <img class="xian3" src="@/assets/xian3.png" alt="">
              <div class="box box3">
                  <p class="title">{{this.$t('langNew.rsy2')}}</p>
                  <p class="num" v-if="currency == 'BTC'">{{profitTotal.day_profit | toFixed4}}</p>
                  <p class="num" v-else>{{profitTotal.day_profit | toFixed2}}</p>
              </div>
          </div>
          <ul class="tab-box">
            <li class="tab" :class="{active: tabIdx == 5}" @click="tab(5)"><div class="text">{{$t('xbsg.shz')}}</div></li>
            <li class="tab" :class="{active: tabIdx == 1}" @click="tab(1)">{{this.$t('langNew.jxz')}}</li>
            <li class="tab" :class="{active: tabIdx == 2}" @click="tab(2)">{{this.$t('langNew.ywc')}}</li>
            <li class="tab" :class="{active: tabIdx == 4}" @click="tab(4)"><div class="text">{{$t('bzhlwdtg.ysh')}}</div></li>
          </ul>
          <div class="tips-bg">{{this.$t('bzhlwdtg.ddztxq')}}</div>
          <ul class="ul-box">
              <li class="list" v-for="(item,index) in listData" :key="index">
                  <div class="list-head">
                      <div class="list-left">
                          <img class="bg1" src="@/assets/new/button_03.png" alt="">
                          <div class="text">{{$t('bzhl.ljsy')}}</div>
                          <div class="num" v-if="item.currency == 'BTC'">{{item.send_fee | toFixed4}}</div>
                          <div class="num" v-else>{{item.send_fee | toFixed2}}</div>
                      </div>
                      <div class="list-right">
                        <div class="sy-title">{{item.no}}</div>
                        <div class="info-box">
                          <div class="info-lt">
                            <div class="t1">{{$t('bzhl.sl')}} {{item.amount}}{{item.currency}}</div>
                            <div class="t2">{{$t('langNew.syl')}} {{item.rate_win}}%</div>
                          </div>
                          <div class="info-rt">
                            <div class="t1">{{$t('bzhl.zq')}} {{item.cycle}} {{$t('langNew.day')}}</div>
                            <div class="t2">{{$t('bzhlgm.tqsh')}} {{item.rate_back}}%</div>
                          </div>
                        </div>
                      </div>
                  </div>
                  <div class="list-foot">
                    <div class="foot-info">
                      <div class="text">{{$t('bzhlwdtg.syts')}} {{item.shengyu_days}} {{$t('langNew.day')}}</div>
                      <!-- <div class="text">{{$t('bzhlwdtg.yhl')}} {{item.send_fee}}{{item.currency}}</div> -->
                      <div class="text">{{$t('bzhlwdtg.xdsj')}} {{item.addtime | timeGs}}</div>
                    </div>
                    <div class="btn-sh" v-show="tabIdx == 1" @click="shuhui(item.id)">{{$t('bzhlwdtg.sh')}}</div>
                  </div>
                  <div class="border border1"></div>
                  <div class="border border2"></div>
                  <div class="border border3"></div>
                  <div class="border border4"></div>
              </li>
              <no-data v-show="hasData"></no-data>
          </ul>
          <img class="go-top" src="@/assets/top.png" alt="" @click="goTop" v-show="isTop">
        </div>
        <!-- <nav-bar navName='loan'></nav-bar> -->
    </div>

</template>

<script>
import navBar from '@/components/NavBar.vue'
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
import VueCircle from '@/pages/circle.vue'
let that = this;
export default {
    name: 'orderStatus',
    data () {
        return {
          token: '',
          lang: 'en',
          listData: [],
          currency: 'USDT',
          profitTotal: {
            total_amount: '',
            day_profit: '',
            total_profit: '',
            order_cnt: ''
          },
          hasData: false,
          isTop: false,
          curDataLength: 10,
          page: 1,
          limit: 10,
          fill : { gradient: ["#40D9FA"]},
          p:10,
          tabIdx: 5
        }
    },
    beforeCreate(){
        that = this;
    },
    created(){
      this.lang = localStorage.getItem('user_lang');
      this.token = localStorage.getItem('token');
      this.currency = this.$route.query.bz || 'USDT';
    },
    mounted() {
      this.getProfitTotal();
      this.getMyprofit();
    },
    methods: {
      goBack(){
        this.$router.push('/loan?bz=' + this.currency)
      },
      tab(idx){
        this.tabIdx = idx;
        this.listData = [];
        this.page = 1;
        this.getMyprofit();
      },
      getMyprofit(){
        let that = this;
        that.isShow = false;
        that.inputList = [{val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}, {val: ""}];
        let params = {
            type: that.tabIdx,
            currency: this.currency,
            page: that.page
        }
        this.$ajax.get('/web/getMyprofit',{params}).then((res) => {
            let resData = res.data.data.data;
            if(res.data.code == 1000){
              // this.$toast.center(res.data.message);
              setTimeout(()=>{
                this.$router.push('/index');
              },1000)
              return false
            }
            if(resData.length > 0){
                that.listData = that.listData.concat(resData);
                that.curDataLength = resData.length;
            }else{
                that.curDataLength = resData.length;
            }
            if(that.listData.length > 0){
                that.hasData = false;
            }else{
                that.hasData = true;
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      shuhui(id){
        this.id = id;
         let params = {
            profit: id,
            tpassword: ''
        }
        this.$ajax.post('/web/sellProfit',params).then((res) => {
          let resData = res.data;
          if(resData.code == 0 || resData.code == 4 || resData.code == 7){
            that.listData = [];
            that.page = 1;
            that.$toast.center(resData.message);
            that.getMyprofit();
          }else{
            that.$toast.center(resData.message);
            return;
          }
        }).catch(function(err){
            console.log(err)
        })
      },
      getProfitTotal(){
        let params = {
          currency: this.currency
        }
        this.$ajax.get('/web/getProfitTotal',{params}).then((res) => {
            let resData = res.data.data;
            if(res.data.code == 1000){
              // this.$toast.center(res.data.message);
              setTimeout(()=>{
                this.$router.push('/index');
              },1000)
              return false
            }
            console.log(resData.total_profit.toFixed(4))
            this.profitTotal = resData;
        }).catch(function(err){
            console.log(err)
        })
      },
      getTotal(){//收益统计
        this.$ajax.get('/web/getTotal').then((res) => {
            if(res.data.code == 0){
                this.profitData = res.data.data;
            }else{
                // this.$router.push('/index')
            }
        }).catch(function(err){
            console.log(err)
        })
      },
      goTop(){
        $('.cont-box').animate({scrollTop:'0px'},'slow');
      },
      listenScroll(e) {  //监听滚动
          let ele = e.srcElement ? e.srcElement : e.target;
          if(ele.scrollTop > 200){
              this.isTop = true
          }else{
              this.isTop = false
          }
          if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
              if(this.curDataLength > 0){
                  this.page ++;
                  this.getProfitList();
              }
          }
      },
    },
    filters: {
        statusText: (val) => {
            if(val == 0){
                return that.xsh
            }else if(val == 1){
                return ''
            }
        },
        times: function(timestamp){
            var date = new Date(timestamp * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + '-';
            var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-');
            var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
            var h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
            var m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
            var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
            return Y + M + D;
        }
    },
    watch: {
        amount: function(val){
            if(val > this.dataDetail.moneylimit){
                this.amount = this.dataDetail.moneylimit;
            }else if(val == ''){
                this.amount = '';
            }else if(val == 0){
                this.amount = 1;
            }else{
                this.amount = val;
            }
        }
    },
    components:{
        navBar,
        noData,
        VueBetterScroll,
        VueCircle
    }
}
</script>
<style scoped>
    input::-webkit-input-placeholder{
        color: #C4C4C4;
        font-size: .42rem;
    }
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        padding: 0 .24rem;
        color: #fff;
        font-size: .52rem;
        line-height: 1.2rem;
        box-sizing: border-box;
        /* background: #0e1530; */
        text-align: center;
    }
    .head .back{
      position: absolute;
      left: 0.3rem;
      top: 0.3rem;
      width: 0.32rem;
      height: 0.6rem;
    }
    .head .icon{
        position: absolute;
        right: .24rem;
        top: 50%;
        font-size: .38rem;
        transform: translateY(-50%);
    }
    .cont-box{
        position: absolute;
        left: 0;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .36rem;
        overflow-y: scroll;
    }
    .ul-box{
        padding: .48rem .24rem;
    }
    .ul-box .list{
        position: relative;
        margin-bottom: .4rem;
    }
    .ul-box .list .list-head{
        position: relative;
        display: flex;
        align-items: center;
        width: 100%;
        margin: 0 .16rem 0 .12rem;
        padding: .24rem .32rem .24rem;
        box-sizing: border-box;
    }
    .ul-box .list .list-head .list-left{
        position: relative;
        width: 3rem;
        height: 3rem;
        margin-right: .3rem;
        text-align: center;
    }
    .ul-box .list .list-right{
      flex: 1;
    }
    .ul-box .list .list-right .sy-title{
      color: #fff;
      font-size: .4rem;
      padding-bottom: .4rem;
    }
    .ul-box .list .list-right .info-box{
      /* display: flex;
      align-items: center;
      justify-content: space-between; */
      color: #cecece;
      font-size: .38rem;
    }
    .ul-box .list .list-right .info-box .info-lt{
      flex: 1.5;
    }
    .ul-box .list .list-right .info-box .t1{
      padding-bottom: .2rem;
    }
    .ul-box .list .list-right .info-box .t2{
      padding-bottom: .2rem;
    }
    .ul-box .list .list-head .bg1{
        position: absolute;
        left: 0;
        top: 0;
        width: 3rem;
        /* height: 2.4rem;    */
    }
    .ul-box .list .list-head .text{
        position: relative;
        z-index: 100;
        padding-top: .9rem;
        color: #6cb5eb;
        font-size: .32rem;
    }
    .ul-box .list .list-head .num{
        position: relative;
        z-index: 100;
        padding-top: .1rem;
        color: #fff;
        font-size: .36rem;
    }
    .ul-box .list .list-head .num.btn-buy{
        position: absolute;
        left: 50%;
        top: 50%;
        width: 1.2rem;
        margin: auto;
        font-size: .48rem;
        word-break: break-all;
        word-break: break-word;
        transform: translate(-50%,-55%);
    }
    .ul-box .list .list-head .num.width-en{
        width: 1.4rem;
    }
    .ul-box .list .border{
        position: absolute;
    }
    .ul-box .list .border1{
        left: 0;
        top: 0;
        width: .56rem;
        height: .48rem;
        border-top: 2px solid #44CFFF;
        border-left: 2px solid #44CFFF;
    }
    .ul-box .list .border2{
        top: 0;
        right: .3rem;
        width: .56rem;
        height: .48rem;
        border-top: 2px solid #44CFFF;
        border-right: 2px solid #44CFFF;
    }
    .ul-box .list .border3{
        left: 0;
        bottom: 0;
        width: .56rem;
        height: .48rem;
        border-bottom: 2px solid #44CFFF;
        border-left: 2px solid #44CFFF;
    }
    .ul-box .list .border4{
        right: .3rem;
        bottom: 0;
        width: .56rem;
        height: .48rem;
        border-bottom: 2px solid #44CFFF;
        border-right: 2px solid #44CFFF;
    }
    .ul-box .list .border5{
        left: 0;
        top: 0;
        width: .64rem;
        height: .48rem;
        /* border-top: 2px solid #f2e9b3; */
        border-top: 2px solid #fff;
        border-left: 2px solid #fff;
    }
    .ul-box .list .type{
        position: absolute;
        top: 0;
        left: 3.4rem;
        /* width: 1.56rem; */
        height: .6rem;
        padding: .16rem .14rem;
        color: #fff;
        font-size: .28rem;
        line-height: .56rem;
        border-left: .12rem solid #39AAD6;
        background: #0F2439;
        text-align: center;

    }
    .ul-box .list .type.ty-box{
        top: -.4rem;
        left: 50%;
        width: 3.7rem;
        font-size: .36rem;
        /* border-right: .05rem solid #39AAD6; */
        transform: translateX(-50%);
    }
    .ul-box .list .type.circly-box1{
        left: 4.3rem;
        top: .84rem;
        padding: .18rem .26rem;
        font-size: .25rem;
        /* border-left: none; */
        background: #0F2439;
    }
    .ul-box .list .type.circly-box{
        left: 4.3rem;
        top: 1.5rem;
        /* border-left: none;
        background: transparent; */
    }
    .ul-box .list .type.rwk{
        left: 4rem;
        top: 2.6rem;
        width: 3.6rem;
        height: auto;
        padding: 0 .14rem;
        border-left: .12rem solid #39AAD6;
        text-align: left;
    }
    .ul-box .list .type.rwkWauto{
        width: auto;
    }
    .ul-box .list .type.money{
        left: 4.02rem;
        top: .78rem;
    }
    .ul-box .list .xian1{
        position: absolute;
        left: 2.8rem;
        top: 0;
        width: .36rem;
        height: .48rem;
    }
    .ul-box .list .xian3{
        position: absolute;
        left: 4rem;
        top: 1.8rem;
        width: .36rem;
        height: .48rem;
    }
    .ul-box .list .xian4{
        position: absolute;
        left: 4rem;
        top: 1.2rem;
        width: .36rem;
        height: .48rem;
    }
    .ul-box .list .star-box{
        position: absolute;
        left: 4.34rem;
        top: -.28rem;
        display: flex;
        align-items: center;
        color: #fff;
        font-size: .36rem;
    }
    .ul-box .list .star-box .tips{
        padding-right: .18rem;
    }
    .ul-box .list .star-box .star{
        width: .42rem;
        height: .42rem;
        margin-right: .04rem;
    }
    .ul-box .list .xian2{
        position: absolute;
        left: 3.5rem;
        top: 2.4rem;
        width: .42rem;
        height: .38rem;
    }
    .ul-box .list .btn{
        position: absolute;
        left: 4.02rem;
        top: 2.66rem;
        /* width: 1.2rem; */
        /* height: .62rem; */
        padding: .2rem .6rem;
        color: #fff;
        font-size: .28rem;
        line-height: .56rem;
        background: rgba(26, 50, 73,.5);
        /* border: 1px solid #39AAD6;        */
        /* border-radius: .1rem; */
        text-align: center;
    }
    .ul-box .list .bg-line{
        width: 100%;
        /* height: .62rem; */
        margin-top: .56rem;
    }
    .status{
        position: absolute;
        right: 0;
        top: 0;
        padding: .18rem .32rem;
        color: #fff;
        font-size: .36rem;
        background: #2CAADE;
        border-radius: 0px 10px 0px 10px;
    }
    .status.active{
        background: #9D9D9D;
    }
    .download-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        position: fixed;
        left: 2%;
        bottom: 1.6rem;
        width: 96%;
        height: 1.8rem;
        padding: 0 .14rem;
        border-radius: 4px;
        background: #3381d5;
        box-sizing: border-box;
    }
    .download-box .logo{
        width: .7rem;
        height: .7rem;
    }
    .download-box .text-box .t1{
        font-size: .38rem;
        margin-bottom: .12rem;
    }
    .download-box .text-box{
        flex: 1;
        margin: 0 .14rem;
        color: #fff;
        font-size: .36rem;
    }
    .download-box .btn{
        margin-right: .42rem;
        padding: .14rem .3rem;
        color: #000;
        font-size: .36rem;
        border-radius: 4px;
        background: #fff;
        text-align: center;
    }
    .download-box .btn-close{
        position: absolute;
        right: .1rem;
        top: .1rem;
        z-index: 999;
        width: .48rem;
        height: .48rem;
    }
    .alert-wrap{
        position: absolute;
        left: 1.82rem;
        right: 1.68rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .28rem;
        transform: translateY(-50%);
    }
    .alert-wrap .alert-head,.alert-wrap2 .alert-head{
        position: relative;
        padding: .48rem 0 .7rem;
        color: #fff;
        font-size: .32rem;
        text-align: center;
    }
    .alert-wrap .alert-head .icon,.alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .42rem;
        top: .42rem;
        width: .42rem;
        height: .42rem;
    }
    .alert-wrap .cont{
        max-height: 8.4rem;
        padding: 0 1.2rem 1rem 1rem;
        color: #fff;
        font-size: .48rem;
        overflow: auto;
    }
    .alert-pay{
        left: 1rem;
        right: 1rem;
        background: rgba(26 ,36, 63,.9);
    }
    .alert-pay .alert-head{
        padding: .7rem .56rem;
        font-size: .48rem;
        border-bottom: 1px solid #313a47;
    }
    .alert-pay .close{
        position: absolute;
        right: .24rem;
        top: .28rem;
        width: .42rem;
    }
    .alert-pay .alert-btn{
        padding: .42rem 0;
        color: #2CAADE;
        font-size: .48rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head{
        position: relative;
        padding: .48rem 0 .7rem;
        color: #fff;
        font-size: .48rem;
        text-align: center;
    }
    .alert-wrap2 .alert-head .icon{
        position: absolute;
        right: .42rem;
        top: .42rem;
        width: .42rem;
        height: .42rem;
    }
    .alert-wrap2{
        position: absolute;
        left: 1rem;
        right: 1rem;
        top: 50%;
        z-index: 1000;
        width: auto;
        background: #1A2440;
        border-radius: .28rem;
        transform: translateY(-50%);
    }
    .alert-wrap2 .tips{
        padding: 0 .6rem .6rem;
        color: #D1D1D1;
        font-size: .36rem;
        text-align: center;
    }
    .alert-wrap2 .btn-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .alert-wrap2 .btn-box .btn{
        width: 50%;
        height: 1.26rem;
        color: #fff;
        font-size: .48rem;
        text-align: center;
    }
    .alert-wrap2 .btn-box .reset{
        background: #4F608E;
        border-radius: 0 0 0 .28rem;
    }
    .alert-wrap2 .btn-box .sure{
        background: #677DB9;
        border-radius: 0 0 .28rem 0;
    }
    .alert-wrap2 .xys-box{
        padding: 0 .7rem .72rem;
    }
    .alert-wrap2 .list{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .24rem .12rem;
        font-size: .48rem;
        border-bottom: 1px solid #484e5e;
    }
    .alert-wrap2 .list .time{
        color: #777981;
    }
    .alert-wrap2 .list .num{
        color: #2CAADE;
    }
    .alert-cont-box{
        height: 10rem;
        overflow-y: auto;
    }
    .alert-wrap3{
        position: absolute;
        left: .18rem;
        right: .18rem;
        bottom: 0;
        z-index: 1000;
        padding: .72rem .24rem .42rem;
        background: rgba(26, 36, 63, .9);
        border-radius: .2rem;
    }
    .alert-wrap3 .tips{
        color: #fff;
        font-size: .48rem;
        text-align: center;
    }
    .alert-wrap3 .btn-close{
        position: absolute;
        right: .72rem;
        top: .72rem;
        width: .56rem;
        height: .56rem;
    }
    .alert-wrap3 .ul-box{
        padding: 1rem 0 1.26rem;
    }
    .alert-wrap3 .ul-box .list{
        display: flex;
        align-items: center;
    }
    .alert-wrap3 .ul-box .list .img{
        width: 1.2rem;
        /* height: .96rem; */
    }
    .alert-wrap3 .ul-box .list .info-box{
        flex: 1;
        margin-left: .28rem;
        color: #cecece;
        font-size: .36rem;
    }
    .alert-wrap3 .ul-box .list .info-box .title{
        color: #fff;
        font-size: .48rem;
    }
    .alert-wrap3 .ul-box .list .info-box .red{
        padding-left: .1rem;
        color: #E02626!important;
        font-size: .48rem;
    }
    .alert-wrap3 .ul-box .list .info-box .price-box{
        display: flex;
        justify-content: space-between;
        /* align-items: center; */
        margin-top: .42rem;
    }
    .alert-wrap3 .ul-box .list .info-box .sl-box{
        display: flex;
        justify-content: space-between;
        /* align-items: center; */
        margin-top: .26rem;
    }
    .alert-wrap3 .ul-box .list .info-box .text1{
        flex: 1.5;
    }
    .alert-wrap3 .ul-box .list .info-box .text2{
        flex: 1;
    }
    .alert-wrap3 .num-wrap{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .3rem .6rem;
        color: #fff;
        font-size: .42rem;
        background: rgba(4, 9, 37, .8);
        border-radius: .4rem;
    }
    .alert-wrap3 .num-wrap .icon{
        width: .54rem;
        height: .54rem;
    }
    .alert-wrap3 .input-box{
        margin: .54rem 0 .9rem;
    }
    .alert-wrap3 .input-box .input{
        width: 100%;
        height: 1.2rem;
        color: #fff;
        font-size: .52rem;
        padding: 0 .54em;
        background: rgba(4, 9, 37, .8);
        /* border: 1px solid #858585; */
        border-radius: .4rem;
        box-sizing: border-box;
    }
    .alert-wrap3 .num-box{
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
    .alert-wrap3 .num-box .input{
        width: 3.2rem;
        color: #fff;
        font-size: .48rem;
        background: #040A26;
        text-align: center;
    }
    .alert-wrap3 .pay-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: auto;
        height: 1.26rem;
        color: #fff;
        line-height: 1.26rem;
        font-size: .4rem;
        background: #040A26;
        border-radius: .68rem;
    }
    .alert-wrap3 .pay-box .t1{
        width: 60%;
        padding-left: .28rem;
    }
    .alert-wrap3 .pay-box .t1 .red{
        padding-left: .24rem;
        color: #2CAADE;
        font-size: .4rem;
    }
    .alert-wrap3 .pay-box .t1 small{
        font-size: .36rem;
    }
    .alert-wrap3 .pay-box .t2{
        width: 40%;
        height: 1.3rem;
        font-size: .48rem;
        background: rgba(44, 170, 222,.5);
        border-radius: 0 .46rem .46rem 0;
        text-align: center;
    }
    .sy-wrap{
        position: relative;
        padding: 1.7rem 0 .8rem;
    }
    .sy-wrap .box{
        position: absolute;
    }
    .sy-wrap .xian1{
        position: absolute;
        top: .46rem;
        left: 3.2rem;
        width: 1.96rem;
        height: 1.24rem;
    }
    .sy-wrap .box1{
        top: .66rem;
        left: 2rem;
        width: 2.88rem;
        height: 1.24rem;
        text-align: center;
    }
    .sy-wrap .xian2{
        position: absolute;
        top: 1.7rem;
        right: 2rem;
        width: 1.84rem;
        height: .74rem;
    }
    .sy-wrap .box2{
        top: 1.8rem;
        right: .6rem;
        z-index: 99;
        width: 3rem;
        text-align: center;
    }
    .sy-wrap .xian3{
        position: absolute;
        top: 4rem;
        left: 2rem;
        width: .82rem;
        height: .64rem;
    }
    .sy-wrap .box3{
        top: 4.56rem;
        left: .3rem;
        text-align: center;
    }
    .sy-wrap .box3 .num{
        text-align: center;
    }
    .sy-wrap .xian4{
        position: absolute;
        top: 4.06rem;
        right: 1.2rem;
        width: .62rem;
        height: .58rem;
    }
    .sy-wrap .box4{
        top: 4.76rem;
        right: .52rem;
    }
    .sy-wrap .box4 .num{
        text-align: center;
    }
    .sy-wrap .box .title{
        /* width: 2rem; */
        padding-top: .14rem;
        color: #3D788C;
        font-size: .42rem;
    }
    .sy-wrap .box3 .title{
        width: 3.6rem;
    }
    .sy-wrap .box .num{
        padding-top: .2rem;
        color: #00BEFF;
        font-size: .45rem;
    }
    .sy-wrap .box1 .num{
        text-align: center;
    }
    .sy-wrap .sy-box{
        position: relative;
        height: 4.8rem;
        text-align: center;
    }
    .sy-wrap .sy-box .bg1{
        position: absolute;
        left: 50%;;
        top: 0;
        width: 4.8rem;
        height: 4.8rem;
        margin-left: -2.18rem;
        animation: turn 10s linear infinite;
    }
    @keyframes turn {
        0% {
            transform: rotate(360deg);
        }

        20% {
            transform: rotate(270deg);
        }

        40% {
            transform: rotate(180deg);
        }

        60% {
            transform: rotate(90deg);
        }

        80% {
            transform: rotate(45deg);
        }

        100% {
            transform: rotate(0deg);
        }
    }
    .sy-wrap .sy-box .bg2{
        position: absolute;
        top: .3rem;
        left: 50%;
        width: 4.32rem;
        height: 4.32rem;
        margin-left: -2.16rem;
        animation: turn2 9s linear infinite;
    }
    @keyframes turn2 {
        0% {
            transform: rotate(0deg);
        }

        20% {
            transform: rotate(72deg);
        }

        40% {
            transform: rotate(144deg);
        }

        60% {
            transform: rotate(216deg);
        }

        80% {
            transform: rotate(288deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
    .sy-wrap .sy-box .t1{
        position: relative;
        z-index: 99;
        width: 4.8rem;
        margin: auto;
        padding-top: 1.5rem;
        color: #6698C9;
        font-size: .35rem;
    }
    .sy-wrap .sy-box .money{
        position: relative;
        z-index: 99;
        padding-top: .3rem;
        color: #4AD1FF;
        font-size: .5rem;
    }
    .tips-bg{
      height: .44rem;
      margin: .5rem .38rem .3rem .34rem;
      color: #67C5E5;
      font-size: .3rem;
      line-height: .44rem;
      background: url('../assets/element.png') no-repeat right center;
      background-size: cover;
    }
    .tab-box{
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding: .2rem .2rem .38rem;
    }
    .tab-box .tab{
        position: relative;
        width: 3.6rem;
        height: .74rem;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #589AB0;
        font-size: .36rem;
        /* line-height: .74rem; */
        text-align: center;
    }
    .tab-box .tab.active{
      padding-left: .3rem;
      color: #67C5E5;
      font-size: .36rem;
      background: url('../assets/choise.png') no-repeat center center;
      background-size: 100% 100%;
    }
    .list-foot{
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: .44rem .32rem 0;
      padding: .26rem 0 .45rem;
      border-top: 1px solid #313a47;
    }
    .list-foot .text{
      padding-top: .18rem;
      color: #cecece;
      font-size: .38rem;
    }
    .list-foot .btn-sh{
      width: 2.42rem;
      height: 0.75rem;
      padding: 0 .1rem;
      color: #fff;
      font-size: .38rem;
      line-height: .75rem;
      background-color: #0060ff;
      border-radius: 0.38rem;
      text-align: center;
     }
</style>
<style lang="">
    .progress .circle-progress-value {
        stroke-width: 6px;
        stroke: #eb47b4;
        stroke-dasharray: 4 1;
    }
    .progress .circle-progress-circle {
        stroke-width: 6px;
        stroke: #eee;
    }
    .progress .circle-progress-text {
        font-weight: bold;
        fill: #18d8d8;
    }
</style>



// WEBPACK FOOTER //
// src/pages/orderStatus.vue